import { ChangeDetectorRef, Component, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccordionComponent } from '@cms/shared-library';
import { TranslateService } from '@ngx-translate/core';
import { PageContentModel } from 'src/app/models/page-content.model';
import { PageContentService } from 'src/app/services/page-content/page-content.service';

@Component({
    selector: 'app-faq-home',
    templateUrl: './faq-home.component.html',
    styleUrl: './faq-home.component.scss',
    standalone: false
})
export class FAQHomeComponent implements OnInit {

  @ViewChildren('cama') camaAccordionList: QueryList<AccordionComponent>;
  @ViewChildren('ec') ecAccordionList: QueryList<AccordionComponent>;
  @ViewChildren('ul') ulAccordionList: QueryList<AccordionComponent>;
  @ViewChildren('rfl') rflAccordionList: QueryList<AccordionComponent>;
  @ViewChildren('rftp') rftpAccordionList: QueryList<AccordionComponent>;
  @ViewChildren('cu') cuAccordionList: QueryList<AccordionComponent>;
  @ViewChildren('mis') misAccordionList: QueryList<AccordionComponent>;

  currentLang: string = 'en';
  pageContents: PageContentModel[];
  initialLoad = true;

  camapageContents: PageContentModel[];
  ecpageContents: PageContentModel[];
  ulpageContents: PageContentModel[];
  rflpageContents: PageContentModel[];
  rftppageContents: PageContentModel[];
  cupageContents: PageContentModel[];
  mispageContents: PageContentModel[];
  constructor(public translateService: TranslateService,
    private cdr: ChangeDetectorRef,
    public route: ActivatedRoute,
    @Inject('PageContentService') public pageContentService: PageContentService) {
    this.currentLang = translateService.currentLang
    translateService.onLangChange.subscribe(lang => {
      this.currentLang = lang.lang
    })
    
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
 this.pageContentService.GetPageContentByPageName("FAQHome") .subscribe(data => {
      this.pageContents = data;

      this.camapageContents = this.getItems('cama')!;
      this.ecpageContents = this.getItems('ec')!;
      this.ulpageContents = this.getItems('ul')!;
      this.rflpageContents = this.getItems('rfl')!;
      this.rftppageContents = this.getItems('rftp')!;
      this.cupageContents = this.getItems('cu')!;
      this.mispageContents = this.getItems('mis')!;
      });

  }
  ngAfterViewChecked(): void {

    if(this.initialLoad && this.camaAccordionList.length >0 && this.ecAccordionList.length>0 && this.ulAccordionList.length>0 && this.rflAccordionList.length>0 && this.rftpAccordionList.length>0 && this.cuAccordionList.length>0 && this.misAccordionList.length>0)
    {
    this.expandOrCollapse(false, this.camaAccordionList);
    this.expandOrCollapse(false, this.ecAccordionList);
    this.expandOrCollapse(false, this.ulAccordionList);
    this.expandOrCollapse(false, this.rflAccordionList);
    this.expandOrCollapse(false, this.rftpAccordionList);
    this.expandOrCollapse(false, this.cuAccordionList);
    this.expandOrCollapse(false, this.misAccordionList);
    this.cdr.detectChanges();
    this.route?.fragment?.subscribe(f => {
      const element = document.querySelector("#" + f)
      if (element) element.scrollIntoView()
    })
    this.initialLoad = false;
    }
   // this.cdr.detectChanges();

  }

  hasOpenAccordion(accordionList: QueryList<AccordionComponent>) {
    return accordionList.filter(x => x.isExpanded == true).length > 0
  }

  expandOrCollapse(collapse: boolean, accordionList: QueryList<AccordionComponent>) {
    accordionList.forEach(x => x.isExpanded = !collapse)
  }

  getItems(name: string) {

    switch (name)
    {
    case 'cama':
    return this.pageContents.filter((item) => item.PageContentOrder  <4 || item.PageContentOrder == 12);
    case 'ec':
    return this.pageContents.filter((item) => item.PageContentOrder ==4);
    case 'ul':
    return this.pageContents.filter((item) => item.PageContentOrder ==5 || item.PageContentOrder ==6);
    case 'rfl':
    return this.pageContents.filter((item) => item.PageContentOrder ==7 || item.PageContentOrder ==8);
    case 'rftp':
    return this.pageContents.filter((item) => item.PageContentOrder ==9);
    case 'cu':
    return this.pageContents.filter((item) => item.PageContentOrder ==10);
    case 'mis':
    return this.pageContents.filter((item) => item.PageContentOrder ==11);
    default:
    return null;
    }
  }
}
